__turbopack_context__.v({
  "number-bubble": "styles-module__mvLLCG__number-bubble",
  "number-bubble-wrapper": "styles-module__mvLLCG__number-bubble-wrapper",
});
